import React from 'react';
import { CSSTransition } from 'react-transition-group';

export const TRANSITION_DURATION = 175;

export const animationTimeout = {
  enter: TRANSITION_DURATION,
  exit: TRANSITION_DURATION,
};

export const FadeTransition = props => (
  <CSSTransition
    {...props}
    classNames="fade"
    timeout={animationTimeout}
  />
);

export const SlideTransition = props => (
  <CSSTransition
    {...props}
    classNames="slide"
    timeout={animationTimeout}
  />
);
